const getDispatchWrapper = (reducerId: any, dispatch: any) => {
  return (action: any) => dispatch({ ...action, reducerId });
};

export default getDispatchWrapper;
